import { ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';

export const findFieldsByComponentName = <T>(
  componentRenderings: ComponentRendering[],
  componentName: string
): T | null => {
  for (const componentRendering of componentRenderings) {
    // Check if the componentName matches the passed name and if fields exist
    if (componentRendering.componentName === componentName && componentRendering.fields) {
      return componentRendering.fields as T;
    }

    // If the component has placeholders, recursively search through them
    if (componentRendering.placeholders) {
      for (const key in componentRendering.placeholders) {
        const result = findFieldsByComponentName<T>(
          componentRendering.placeholders[key] as ComponentRendering[],
          componentName
        );
        if (result) {
          return result;
        }
      }
    }
  }

  return null;
};
